import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import type { OperateWizardState } from '../operateWizardReducer';

import { getEffectiveSteps, STEP_LABEL_KEYS } from './wizardSteps';

import styles from '../operateModals.module.scss';

interface StepIndicatorProps {
    state: OperateWizardState;
    includeBioscopeStep: boolean;
}

export function StepIndicator(props: StepIndicatorProps) {
    const { state, includeBioscopeStep } = props;
    const { t } = useTranslation('fishGroups');
    const steps = getEffectiveSteps(state, includeBioscopeStep);
    const currentIndex = steps.indexOf(state.step);

    return (
        <ol className={styles.stepIndicator}>
            {steps.map((stepName, index) => (
                <li
                    key={stepName}
                    className={classNames(styles.step, {
                        [styles['step--active']]: index === currentIndex,
                        [styles['step--completed']]: index < currentIndex,
                    })}>
                    {index + 1}. {t(STEP_LABEL_KEYS[stepName])}
                </li>
            ))}
        </ol>
    );
}
